import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Col,Nav} from 'react-bootstrap';

import CompanyInfo from './tabContent/companyInfo';
import Address from './tabContent/address';
import PrimaryContact from './tabContent/primaryContact';
import Settings from './tabContent/settings';
import DynamicFieldsDetails from '../commons/dynamicFieldsDetails'; 

import Toast from '../commons/helpers/toast';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import { LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,TAB1, TAB2, TAB3,TAB4,ROUTE_AFFILIATE_PROFILE, ROUTE_AFFILIATE_PROFILE_MANAGE, DYNAMIC_PAGE_ICONS,SEARCH_TEXT_COUNT,ROUTE_AFFILIATES, DEFAULT_TIME_ZONE,MILES, QUOTE_VALIDITY_DAYS, STR_VEHICLE_INFO, ROUTE_AFFILIATE_SETTINGS } from '../../configs/staticConfigs';

import {MSG_LOGO_FORMAT,MSG_MAIL_RESEND, MSG_FILE_FORMAT_ERROR, MSG_FILE_SIZE_ERROR, MSG_PROF_PRMY_CNT_ADD, MSG_ERROR, MSG_REQUIRED, MSG_PROF_CMPNY_INFO_ADD, MSG_PROF_ADDRESS_UPDATE, MSG_PROF_PRMY_CNT_UPDATE, MSG_PROF_SETTINGS_UPDATE, MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS, MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR, MSG_TIMEZONE_DATA_ERROR, MSG_AFFILIATE_ADD_ERROR, MSG_TRAVEL_MODULE_FIELDS_ERROR} from '../../configs/msgConfigs';

import { LBL_APP_NAME, LBL_SETTINGS, LBL_COMPANY_PROFILE, LBL_AFFILIATES, LBL_ADD_AFFILIATE, LBL_BACK_TO_SETTINGS, LBL_TRAVEL_MODULE_FIELDS_CHOOSE, LBL_PAY_RATE_CHARGE_RATE_ERROR} from '../../configs/labelConfigs';

import {sectorAllListAction} from '../../actions/settings/superadmin/sectorActions';
import {subSectorAllListAction} from '../../actions/settings/superadmin/subSectorActions';
import {affiliateCompanyInfoAddAction, affiliateEditAction, affiliateCmnyInfoUpdateAction, affiliateAddressUpdateAction, affiliatePrmryCntUpdateAction, affiliateSettingsUpdateAction} from '../../actions/affiliateActions';
import {clearAction, currencyListAction,masterLocationListAction, primaryUsersListAction, resendEmailAction, timeZonesListAction} from '../../actions/commonActions';
import { dynamicFieldsListAction, dynamicFieldsDataSaveAction } from '../../actions/settings/dynamicFieldsActions'; 

import * as types from '../../actions'; 

import {formValid,decimalNumRegex,numRegex,imageExtension,fileSize,validateEmail} from '../../utils/validation';

import {appendVenueLoc} from '../../utils/commonUtilities';
import {setStorage} from '../../utils/browserStorage'; 

import * as gLoc from '../../configs/googleConfigs'; 
import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';
import { format } from 'date-fns';
import getCroppedImg from '../commons/image-cropper/cropImage';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import ModalWindow from '../commons/helpers/modalWindow';
//import { isFirstDayOfMonth } from 'date-fns/fp';

class AffiliateProfileComponent extends Component {

    constructor(props){
        super(props)

        let profileId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup    = ''; 
        let grpProfileId = '';
        let distance_unit = MILES;
        let isSuperAdmin = false; 

        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            grpProfileId = userGroupData.profile_id;
            distance_unit = userGroupData.distance_unit;
        }

        if(userGroup===LOGIN_SUPER_ADMIN_GROUP){
            isSuperAdmin = true; 
        }

        if(userGroup===LOGIN_AFFILIATE_GROUP){
            profileId = grpProfileId;
        }else{
            profileId = this.props.match.params.id;
        }

        // crewChiefPayRate:'', crewChiefChargeRate:'',

        this.state = {                    
            formErrors:{
                companyName: '',
                companyContactNum:'',
                companyEmail:'',
                websiteUrl:'',
                sector:'',
                subSector:'',
                vatTax:'',
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',
                firstName:'',
                lastName:'',
                contactNumber:'',
                emailAddress:'',
                minDistance:'',
                crewCountChief:'',
                rate:'',
                appCommision:'',
                poolCommision:'',         
                crewChiefChargeRateLess:'', 
                timeZone:'',
                startTime:'',
                timeAllowedTime:'',
                checkoutTime:'',
                supervisorName:'',
                staffName:'',
                minShiftLength:'',
                minimumTravelDistance:'',
                travelTimeRounding:'',
            },          
            affiliateData:{
                companyInfo:{
                    companyName:null,
                    websiteUrl:'',
                    companyContactNum:'',
                    companyEmail:'',
                    companyRegNum:'',
                    vatNum:'',
                    vatTax:null,
                    sector:0,
                    subSector:0,
                    logo:'',
                },            
                affiliateAddress:{
                    locationId:null,
                    location:'',
                    googleLocation:'',
                    venue:'',
                    streetOne:null,
                    streetTwo:null,
                    city:null,
                    state:null,
                    country:null,
                    postcode:null,
                    noLocationFound:false
                },
                primaryContact:{
                    firstName:null,
                    lastName:null,
                    contactNumber:null,
                    emailAddress:null,
                    position:'',
                    prmyCnctAssUserId:'',
                    prmyCnctUserId:'',
                    emailVerify:true,
                    muteMails:false,
                    mutePushs:false,

                },
                profileSettings:{ 
                    distanceUnit:distance_unit,
                    currency:'',
                    quoteValidity:QUOTE_VALIDITY_DAYS,
                    crewCountChief:null,
                    minDistance:0,
                    rate:0,
                    appCommision:null,
                    poolCommision:null,
                    additionalText:'',
                    timeZone:null, 
                    startTime:"00:15", 
                    timeAllowedTime:"02:00", 
                    checkoutTime:"01:00", 
                    supervisorName:"Supervisor",
                    staffName:"Staff",
                    minShiftLength:"",
                    muteClientEmails: false,
                    isPrimaryUserLogin: false, 
                    travelSettings: { 
                        travel_module_admin_activate: false, 
                        travel_module_affiliate_activate: false, 
                        minimum_travel_distance: 0, 
                        staff_per_vehicle: 0,                        
                        travel_time_rounding:'',
                        travel_fields: []
                    },  
                    travelModuleMasterFields: [],
                }, 
                activeTab:TAB1,
            },
            profileId:profileId, 
            userGroup:userGroup,
            imgUrl:null,   
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,
            isPrmCnctList:false,
            isPrimaryContactSuccess:false,
            logoLabel:MSG_LOGO_FORMAT,
            isLogoValid:true,
            listDynData: {groupId: 0, reqFrom:0},
            dynFieldsAllItems: [],  
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },    
            activePageId: 0, 
            dynamicFieldsSavedData: [],
            dynamicFieldsSavedDataLoaded: 0,
            currentUrl:this.props.location,
            locGoogleCodes: {
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',   
            }, 
            timeZonesList: [], 
            defaultTimeZoneId:0,
            primaryContactEmailAddress: '',
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea:{},
            croppedAreaPixels:{},
            rotation:0,
            imgObj:null,
            isSuperAdmin:isSuperAdmin,
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.saveFormData   = this.saveFormData.bind(this);
        this.onTabChange    = this.onTabChange.bind(this);
        this.changePage     = this.changePage.bind(this); 

        this.logoModalCropper = React.createRef(); 
        this.modalTravelModuleFields = React.createRef(); 
    }

    changePage = (event, refPageId) => { 

        if(this.state.activePageId!==refPageId) {
            let allPagesFieldsObj = []; 
            let newActiveObj = {};
            this.state.dynFieldsAllItems.forEach((item,index) => {
                if(item.id===this.state.activePageId) allPagesFieldsObj.push(this.state.dynFieldsActiveItem); 
                else allPagesFieldsObj.push(item); 
                if(item.id===refPageId)  {
                    newActiveObj = item;
                }
            }); 
            this.setState({activePageId:refPageId, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems:allPagesFieldsObj,toastFlag:false,toastMessage:'',toastSuccess:true}); 
        }   
    }

    onHandleChange = (e, tab) =>{
        const {name}  = e.target;
        let value   = e.target.type === "file" ? e.target.files[0] : e.target.type==='checkbox'?e.target.checked:e.target.value;  
        
        let trimmedValue = '';
        if(e.target.type==="text" || e.target.type==="tel" || e.target.type==="email"){
            trimmedValue = value.trim(); 
        }
        let formErrors      = this.state.formErrors;
        let logoValid       = true;
        let logoError       = MSG_LOGO_FORMAT;               
        let arrTmp = []; 
        switch(name){
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError     = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if(!imageExtension(value.name)){
                    logoError     = MSG_FILE_FORMAT_ERROR;
                    logoValid = false;
                }      
                break; 
            case 'companyName':
                formErrors.companyName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;             
            case 'companyEmail':
                formErrors.companyEmail = 
                trimmedValue.length >0 && validateEmail(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;  
            case 'websiteUrl':
                formErrors.websiteUrl = "";               
                break;
            case 'sector':
                formErrors.sector = 
                (this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && (value.length <=0 || Number(value)===0))
                ? MSG_REQUIRED
                : ""
                break;  
            case 'subSector':
                formErrors.subSector = 
                (this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && (value.length <=0 || Number(value)===0))
                ? MSG_REQUIRED
                : ""
                break; 
            case 'vatTax':
                formErrors.vatTax = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;
            case 'firstName':
                formErrors.firstName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            case 'lastName':
                formErrors.lastName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;     
            case 'contactNumber':
                formErrors.contactNumber = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;        
            case 'emailAddress':
                formErrors.emailAddress = 
                trimmedValue.length <=0 || validateEmail(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;  
            // case 'streetOne':
            //     formErrors.streetOne = 
            //     trimmedValue.length <=0 
            //     ? MSG_REQUIRED
            //     : ""
            //     break;   
            // case 'streetTwo':
            //     formErrors.streetTwo = 
            //     trimmedValue.length <=0 
            //     ? MSG_REQUIRED
            //     : ""
            //     break;   
            case 'city':
                formErrors.city = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;    
            case 'state':
                formErrors.state = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            case 'country':
                formErrors.country = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'postcode':
                formErrors.postcode = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'minDistance':
                formErrors.minDistance = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                // LIMITED TO 2 DECIMAL POINTS 
                arrTmp = trimmedValue.split('.'); 
                if(arrTmp.length > 1) {
                    if(arrTmp[1].length > 2) arrTmp[1] = arrTmp[1].substring(0,2); 
                    value = arrTmp[0]+'.'+arrTmp[1]; 
                }
                break;
            case 'crewCountChief':
                formErrors.crewCountChief = 
                trimmedValue.length <=0 || numRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;
            case 'rate':
                formErrors.rate = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                // LIMITED TO 2 DECIMAL POINTS 
                arrTmp = trimmedValue.split('.'); 
                if(arrTmp.length > 1) {
                    if(arrTmp[1].length > 2) arrTmp[1] = arrTmp[1].substring(0,2); 
                    value = arrTmp[0]+'.'+arrTmp[1]; 
                }
                break;
            case 'appCommision':
                formErrors.appCommision = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;
            case 'poolCommision':
                formErrors.poolCommision = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
                break;
            case 'supervisorName':
                formErrors.supervisorName = 
                trimmedValue.length <=0
                ? MSG_REQUIRED
                : ""
                break;
            case 'staffName':
                formErrors.staffName = 
                trimmedValue.length <=0
                ? MSG_REQUIRED
                : ""
                break;
            case 'timeZone':
                formErrors.timeZone = (value.length <=0 || Number(value)===0) ? MSG_REQUIRED : ""; 
                break;    
            case 'minimumTravelDistance': 
                formErrors.minimumTravelDistance = 
                trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
                ? MSG_REQUIRED
                : ""; 
                break; 

            // case 'crewChiefPayRate':
            //     formErrors.crewChiefChargeRateLess = ''; 
            //     formErrors.crewChiefPayRate = 
            //     trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
            //     ? MSG_REQUIRED
            //     : ""
            //     break;    

            // case 'crewChiefChargeRate':
            //     formErrors.crewChiefChargeRateLess = ''; 
            //     formErrors.crewChiefChargeRate = 
            //     trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
            //     ? MSG_REQUIRED
            //     : ""
            //     break;
                
            default :
            break;
        }

        let affiliateData      = this.state.affiliateData;
      
        let companyInfo        = this.state.affiliateData.companyInfo;
        let affiliateAddress   = this.state.affiliateData.affiliateAddress;
        let primaryContact     = this.state.affiliateData.primaryContact;
        let profileSettings    = this.state.affiliateData.profileSettings;

        if(tab===TAB1){
            companyInfo[name] = value;
        }else if(tab===TAB2){       
            affiliateAddress[name] = value;
        }else if(tab===TAB3){
            primaryContact[name] = value;
        }else if(tab===TAB4){
            profileSettings[name] = value;
        }  
        
        if(e.target.type=== "file"){
            let imgUrl = '';
            let imgObj = null;
            if(imageExtension(e.target.files[0].name)){
                imgObj = e.target.files[0]
                imgUrl = URL.createObjectURL(e.target.files[0]);
            }
            this.setState({imgUrl:imgUrl,imgObj:imgObj});
            document.getElementById('uploadLogo').value = '';
            this.openCropModal()
        }
        this.setState({formErrors,affiliateData,isLogoValid:logoValid,logoLabel:logoError});
    } 

    // CALLED FROM settings.js
    onHandleChangeTravelFields = (e, fieldId, fieldType) =>{
        
        if(fieldType==='travelModuleSuperAdminActivate') {
            const isChecked = e.target.checked;
            this.setState((prevState) => ({
                affiliateData: {
                    ...prevState.affiliateData,
                    profileSettings: {
                        ...prevState.affiliateData.profileSettings,
                        travelSettings: {
                            ...prevState.affiliateData.profileSettings.travelSettings,
                            travel_module_admin_activate: isChecked,
                        },
                    },
                    },
                }
            ));
        } else if(fieldType==='travelModuleAffiliateActivate') {
            const isChecked = e.target.checked;
            this.setState((prevState) => ({
                affiliateData: {
                    ...prevState.affiliateData,
                    profileSettings: {
                        ...prevState.affiliateData.profileSettings,
                        travelSettings: {
                            ...prevState.affiliateData.profileSettings.travelSettings,
                            travel_module_affiliate_activate: isChecked,
                        },
                    },
                    },
                }
            )); 
        } else if(fieldType==='minimumTravelDistance') {
            const minDist = (e.target.value).replace(/[^0-9.]/g, '');
            this.setState((prevState) => ({
                affiliateData: {
                    ...prevState.affiliateData,
                    profileSettings: {
                        ...prevState.affiliateData.profileSettings,
                        travelSettings: {
                            ...prevState.affiliateData.profileSettings.travelSettings,
                            minimum_travel_distance: minDist,
                        },
                    },
                    },
                }
            )); 
        } else if(fieldType==='staffPerVehicle') {
            const staffVeh = (e.target.value).replace(/\D/g, '');
            this.setState((prevState) => ({
                affiliateData: {
                    ...prevState.affiliateData,
                    profileSettings: {
                        ...prevState.affiliateData.profileSettings,
                        travelSettings: {
                            ...prevState.affiliateData.profileSettings.travelSettings,
                            staff_per_vehicle: staffVeh,
                        },
                    },
                    },
                }
            )); 
        } else if(fieldType==='travelFieldCheckbox') {
            let isChecked = e.target.checked; 
            this.setState(prevState => {
                const currentFields = prevState.affiliateData.profileSettings.travelSettings.travel_fields;
                let updatedFields;
                if (isChecked) { // ✅ ADD IF NOT ALREADY EXISTS 
                    const exists = currentFields.some(field => Number(field.field_id) === Number(fieldId));
                    if (!exists) {
                        updatedFields = [...currentFields, { field_id:fieldId, field_value: 0, pay_rate_driver_vehicle: 0,pay_rate_affiliate_vehicle:0, pay_rate_passenger:0 }]; 
                    } else {
                        updatedFields = currentFields; // no changes if already exists
                    }
                } else { // ❌ REMOVE IF EXISTS 
                    updatedFields = currentFields.filter(field => Number(field.field_id) !== Number(fieldId));
                }

                return {
                    affiliateData: {
                        ...prevState.affiliateData,
                        profileSettings: {
                            ...prevState.affiliateData.profileSettings,
                            travelSettings: {
                                ...prevState.affiliateData.profileSettings.travelSettings,
                                travel_fields: updatedFields
                            }
                        },
                    },
                };
            });
        } else if (['travelFieldValue', 'pay_rate_driver_vehicle', 'pay_rate_affiliate_vehicle', 'pay_rate_passenger'].includes(fieldType)) {
                let newValue = e.target.value.replace(/[^0-9.]/g, '');

                // tmFieldItem.field_type == TM_FIELD_DISTANCE_ID || tmFieldItem.field_type == TM_FIELD_TIME_ID
                
                this.setState(prevState => {
                    const updatedFields = prevState.affiliateData.profileSettings.travelSettings.travel_fields.map(field => {
                        if (Number(field.field_id) === Number(fieldId)) {
                            return { ...field, [fieldType === 'travelFieldValue' ? 'field_value' : fieldType]: newValue };
                        }
                        return field;
                    });


                    return {
                        affiliateData: {
                            ...prevState.affiliateData,
                            profileSettings: {
                                ...prevState.affiliateData.profileSettings,
                                travelSettings: {
                                    ...prevState.affiliateData.profileSettings.travelSettings,
                                    travel_fields: updatedFields
                                }
                            },
                        },
                    };
                });
            }

    }

    openCropModal =() =>{
        this.logoModalCropper.current.handleOpenModal();
    }

    onSearchLocation = (query) =>{
        if(query.length>=SEARCH_TEXT_COUNT){
            this.props.masterLocationListAction(query);
        }
           
    }
    onHandleChangeStartTime = (time) =>{
        let {formErrors,affiliateData} = this.state;    
        if(time._d !== undefined){
            let startTime = format(new Date(time._d), 'HH:mm');           
            affiliateData.profileSettings['startTime'] = startTime;
            this.setState({affiliateData,formErrors});
        }
    }

    onBlurStartTime = (time) =>{
        let {formErrors, affiliateData} = this.state;
        if(time._d !== undefined){
            let startime = format(new Date(time._d), 'HH:mm');
            affiliateData.profileSettings['startTime'] = startime;
            formErrors.startTime = '';
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                let startime = format(d, 'HH:mm');
                affiliateData.profileSettings['startTime'] = startime;
                formErrors.startTime = '';
            }catch(err) {
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                d.setHours(hours);
                d.setMinutes(minutes);
                let startime = format(d, 'HH:mm');
                affiliateData.profileSettings['startTime'] = '';
                this.setState({affiliateData,formErrors});
                affiliateData.profileSettings['startTime'] = startime
            }
        } 
        this.setState({affiliateData,formErrors});       
    }

    onHandleChangeTimeAllowedTime = (time) =>{
        let {formErrors,affiliateData} = this.state;    
        if(time._d !== undefined){
            let timeAllowedTime = format(new Date(time._d), 'HH:mm');           
            affiliateData.profileSettings['timeAllowedTime'] = timeAllowedTime;
            this.setState({affiliateData,formErrors});
        }
    }


    onBlurTimeAllowedTime = (time) =>{
        let {formErrors, affiliateData} = this.state;
        if(time._d !== undefined){
            let timeAllowedTime = format(new Date(time._d), 'HH:mm');
            affiliateData.profileSettings['timeAllowedTime'] = timeAllowedTime;
            formErrors.timeAllowedTime = '';
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                let timeAllowedTime = format(d, 'HH:mm');
                affiliateData.profileSettings['timeAllowedTime'] = timeAllowedTime;
                formErrors.timeAllowedTime = '';
            }catch(err) {
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                d.setHours(hours);
                d.setMinutes(minutes);
                let timeAllowedTime = format(d, 'HH:mm');
                affiliateData.profileSettings['timeAllowedTime'] = '';
                this.setState({affiliateData,formErrors});
                affiliateData.profileSettings['timeAllowedTime'] = timeAllowedTime
            }
        } 
        this.setState({affiliateData,formErrors});       
    }
   
    onHandleTravelTimeRounding = (time) =>{
        let {formErrors,affiliateData} = this.state;    
        if(time._d !== undefined){
            let travelTimeRounding = format(new Date(time._d), 'HH:mm');           
            affiliateData.profileSettings.travelSettings['travel_time_rounding'] = travelTimeRounding;
            this.setState({affiliateData,formErrors});
        }
    }
     
    onBlurTravelTimeRounding = (time) =>{
        let {formErrors, affiliateData} = this.state;
        if(time._d !== undefined){
            let travelTimeRounding = format(new Date(time._d), 'HH:mm');
            affiliateData.profileSettings.travelSettings['travel_time_rounding'] = travelTimeRounding;
            formErrors.travelTimeRounding = '';
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                let travelTimeRounding = format(d, 'HH:mm');
                affiliateData.profileSettings.travelSettings['travel_time_rounding'] = travelTimeRounding;
                formErrors.travelTimeRounding = '';
            }catch(err) {
                affiliateData.profileSettings.travelSettings['travel_time_rounding'] = '';
            }
        } 
        this.setState({affiliateData,formErrors});       
    }

    onHandleChangeMinShiftLength = (time) =>{
        let {formErrors,affiliateData} = this.state; 

        if(time._d !== undefined){
            let minShiftLength = format(new Date(time._d), 'HH:mm');           
            affiliateData.profileSettings['minShiftLength'] = minShiftLength;
            this.setState({affiliateData,formErrors});
        }
    }

    onBlurMinShiftLength = (time) =>{
        let {formErrors, affiliateData} = this.state;
        if(time._d !== undefined){
            let minShiftLength = format(new Date(time._d), 'HH:mm');
            affiliateData.profileSettings['minShiftLength'] = minShiftLength;
            formErrors.minShiftLength = '';
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                let minShiftLength = format(d, 'HH:mm');
                affiliateData.profileSettings['minShiftLength'] = minShiftLength;
                formErrors.minShiftLength = '';
            }catch(err) {
                affiliateData.profileSettings['minShiftLength'] = '';
            }
        } 
        this.setState({affiliateData,formErrors});       
    }

    onHandleChangeCheckoutTime = (time) =>{
        let {formErrors,affiliateData} = this.state;    
        if(time._d !== undefined){
            let checkoutTime = format(new Date(time._d), 'HH:mm');           
            affiliateData.profileSettings['checkoutTime'] = checkoutTime;
            this.setState({affiliateData,formErrors});
        }
    }

    onBlurCheckoutTime = (time) =>{
        let {formErrors, affiliateData} = this.state;
        if(time._d !== undefined){
            let checkoutTime = format(new Date(time._d), 'HH:mm');
            affiliateData.profileSettings['checkoutTime'] = checkoutTime;
            formErrors.checkoutTime = '';
            
        }else{
            try{
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                var s = time.trim();
                var parts = s.match(/(\d+)\:(\d+)/);
                if(parts == null && s.slice(-1) == ":"){
                    parts = s.match(/(\d+)\:/)
                    hours = parseInt(parts[1], 10);
                    minutes = 0;
                }else{
                    hours = parseInt(parts[1], 10);
                    minutes = parseInt(parts[2], 10);
                }
                
                d.setHours(hours);
                d.setMinutes(minutes);
                let checkoutTime = format(d, 'HH:mm');
                affiliateData.profileSettings['checkoutTime'] = checkoutTime;
                formErrors.checkoutTime = '';
            }catch(err) {
                var hours = 0;
                var minutes = 0;
                var d = new Date();
                d.setHours(hours);
                d.setMinutes(minutes);
                let checkoutTime = format(d, 'HH:mm');
                affiliateData.profileSettings['checkoutTime'] = '';
                this.setState({affiliateData,formErrors});
                affiliateData.profileSettings['checkoutTime'] = checkoutTime
            }
        } 
        this.setState({affiliateData,formErrors});       
    }

    onTabChange = (e,tab) =>{
        let affiliateData = this.state.affiliateData;
        affiliateData['activeTab'] = tab;
        let firstObj = {}
        this.setState({affiliateData:affiliateData, activePageId: 0, dynFieldsActiveItem: firstObj});
        this.resetFormErrors();
        if(tab===TAB4 && this.state.timeZonesList.length===0) {
            this.props.timeZonesListAction(); 
        }
    }

    onSelectLocation = (selected) =>{
        if(selected.length>0) {
            let selectedLoc      = selected[0];
            let affiliateData    = this.state.affiliateData;
            let affiliateAddress = this.state.affiliateData.affiliateAddress;
            
            affiliateAddress['locationId'] = selectedLoc.id;
            affiliateAddress['location'] = (selectedLoc.location)?selectedLoc.location:'';
            affiliateAddress['googleLocation'] = (selectedLoc.lat_long)?selectedLoc.lat_long:'';
            affiliateAddress['venue'] = (selectedLoc.venue) ? selectedLoc.venue : '';
            affiliateAddress['streetOne'] = (selectedLoc.street1)?selectedLoc.street1:'';
            affiliateAddress['streetTwo'] = (selectedLoc.street2)?selectedLoc.street2:'';
            affiliateAddress['city'] = (selectedLoc.city)?selectedLoc.city:'';
            affiliateAddress['state'] = (selectedLoc.state)?selectedLoc.state:'';
            affiliateAddress['country'] = (selectedLoc.country)?selectedLoc.country:'';
            affiliateAddress['postcode'] = (selectedLoc.postcode)?selectedLoc.postcode:'';
            this.setState({affiliateData});
            this.resetFormErrors();
        }        
        
    }

    onPhoneInputChange = (value, data, event, formattedValue) =>{
        let affiliateData   = this.state.affiliateData;     
        let companyInfo  = this.state.affiliateData.companyInfo;
        companyInfo['companyContactNum'] = formattedValue.trim();
        
        this.setState({affiliateData});
    }

    onContactInputChange = (value, data, event, formattedValue) =>{
        let affiliateData   = this.state.affiliateData; 
        let formErrors = this.state.formErrors;
        let primaryContact   = this.state.affiliateData.primaryContact
        primaryContact['contactNumber'] = formattedValue.trim();
        formErrors.contactNumber = value.trim()===data.dialCode ? MSG_REQUIRED : "";
        formErrors.contactNumber = formattedValue.trim().length<5 ? MSG_REQUIRED : "";
        this.setState({formErrors,affiliateData});
    }

    resetFormErrors=()=>{
        let formErrors = this.state.formErrors;
    
        formErrors.companyName = '';
        formErrors.websiteUrl = '';
        formErrors.sector = '';
        formErrors.subSector = '';
        formErrors.vatTax = '';
        formErrors.firstName = '';
        formErrors.lastName = '';
        formErrors.contactNumber = '';
        formErrors.emailAddress = '';
        formErrors.streetOne = '';
        formErrors.streetTwo = '';
        formErrors.city = '';
        formErrors.state = '';
        formErrors.country = '';
        formErrors.postcode = '';
        formErrors.minDistance = '';
        formErrors.crewCountChief = '';
        // formErrors.crewChiefPayRate = '';
        // formErrors.crewChiefChargeRate = '';
        formErrors.crewChiefChargeRateLess = ''; 
        formErrors.rate = '';
        formErrors.appCommision = '';
        formErrors.poolCommision = '';
        formErrors.timeZone = ''; 
        formErrors.minimumTravelDistance = ''; 
        this.setState({formErrors});
    }

    onSelectPrmyUser = (e) =>{

        let affiliateData    = this.state.affiliateData;
        let primaryContact   = this.state.affiliateData.primaryContact;
        primaryContact['prmyCnctAssUserId'] = e.target.value;
        const filteredUsers = this.props.prmryUsers.filter(item => item.associate_id === Number(e.target.value));
        primaryContact['firstName'] = filteredUsers[0].first_name;
        primaryContact['lastName'] = filteredUsers[0].last_name;
        primaryContact['contactNumber'] = filteredUsers[0].phone_number;
        primaryContact['emailAddress'] = filteredUsers[0].email;
        primaryContact['position'] = filteredUsers[0].position;
        primaryContact['mutePushs'] = filteredUsers[0].mute_pushs;
        primaryContact['muteMails'] = filteredUsers[0].mute_mails;
        this.setState({affiliateData});
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 3000);
        } 
        // else{
        //     setTimeout(()=> {
        //         this.onCloseToast();
        //     }, 10000000000000);
        // }
    }

    resendEmail =(userId)=>{
        this.props.resendEmailAction(userId);
    }
  
    saveFormData = (e)=>{
        e.preventDefault(); 
        this.setState({formClick:true});

        const profileId = this.state.profileId; 

        const data = new FormData(); 

        if(formValid(this.state)&&this.state.isLogoValid){

            let companyInfo   = this.state.affiliateData.companyInfo;
            
            data.append('company_name', companyInfo.companyName);            
            data.append('web_site', companyInfo.websiteUrl);
            data.append('phone_number', companyInfo.companyContactNum);
            data.append('company_email', companyInfo.companyEmail);
            data.append('company_reg_no', companyInfo.companyRegNum);
            data.append('vat_number', companyInfo.vatNum);
            data.append('vat', companyInfo.vatTax);
            if(Number(companyInfo.sector) > 0) data.append('sector', companyInfo.sector);
            else data.append('sector', '');
            if(Number(companyInfo.sector) > 0 && Number(companyInfo.subSector) > 0)  data.append('sub_sector', companyInfo.subSector);   
            else data.append('sub_sector', '');   

            if(companyInfo.logo!==''){
                data.append('logo', companyInfo.logo);
            }

            if(profileId===undefined){                
                this.props.affiliateCompanyInfoAddAction(data);
            }else{
                data.append('id', profileId);  
                this.props.affiliateCmnyInfoUpdateAction(data);
            }           

        }else{
            let formErrors = this.state.formErrors;
            const {companyInfo} = this.state.affiliateData;
            if(companyInfo.companyName===null){
                formErrors.companyName = MSG_REQUIRED;
            }
            if(this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP) { 
                if(companyInfo.sector===0){
                    formErrors.sector = MSG_REQUIRED;
                }  
                if(companyInfo.subSector===0 || !companyInfo.subSector){
                    formErrors.subSector = MSG_REQUIRED;
                }   
            }    
            if(companyInfo.vatTax===null){
                formErrors.vatTax = MSG_REQUIRED;
            }  

            this.setState({formErrors});
        }
        
    }

    cropImage(e){
        let {imgObj,croppedAreaPixels,rotation,imgUrl} = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            'affProfile'
        )

    }

    validateAffiliateTravelFields = () => {
        // FOR SUPERADMIN LOGIN - ONLY ACTIVATE TRAVEL COST CHECK BOX - NO VALIDATIONS NEEDED
        if(this.state.isSuperAdmin) return true; 

        const profileSettings = this.state.affiliateData.profileSettings;
        if(profileSettings.travelSettings.travel_module_admin_activate && profileSettings.travelSettings.travel_module_affiliate_activate && profileSettings.travelSettings.travel_fields.length===0) {
            this.setToasterState(true,MSG_TRAVEL_MODULE_FIELDS_ERROR,false);  
            return false;
        } 

        const travelSettings = this.state.affiliateData.profileSettings.travelSettings;
        if(parseInt(travelSettings.staff_per_vehicle,10)<=0 || (travelSettings.staff_per_vehicle).toString().trim()=='') { 
            // NO NEED TO SHOW WARNING< THE TEXT FIELD ITSELF WILL BE RED IN THIS CASE
            return false;
        }
        
        const hasInvalidRate = travelSettings.travel_fields.some(field => {
            const fieldValue = Number(field.field_value || 0);
            const payRateOwn = Number(field.pay_rate_driver_vehicle || 0);
            const payRateAffiliate = Number(field.pay_rate_affiliate_vehicle || 0);
            const payRatePassenger = Number(field.pay_rate_passenger || 0);

            const isFieldEmpty = (field.field_value).toString().trim() === '';

            const passengerInvalid =
                (payRateOwn + payRatePassenger) > fieldValue ||
                (payRateAffiliate + payRatePassenger) > fieldValue;

            return isFieldEmpty || passengerInvalid;
            });

            if (hasInvalidRate) {
            this.setToasterState(true, LBL_PAY_RATE_CHARGE_RATE_ERROR, false);
            return false;
            }
        

        return true; 
    }

    updateFormData = (e, tab) =>{
        e.preventDefault();
        this.setState({formClick:true}); // to track form update without any value change in component did update

        const profileId = this.state.profileId; 
        if(tab===TAB2){
            let affiliateAddress = this.state.affiliateData.affiliateAddress;
            if(formValid(this.state)){
                let addressData= {}; 
                if(!affiliateAddress.locationId || affiliateAddress.locationId==='') {
                    let locName = appendVenueLoc(affiliateAddress.location,affiliateAddress.venue); 
                    addressData = {
                        profileId:profileId,
                        location: locName?locName:'',
                        venue: (affiliateAddress.venue) ? affiliateAddress.venue : '',
                        street1:(affiliateAddress.streetOne)?affiliateAddress.streetOne:'',
                        street2:(affiliateAddress.streetTwo)?affiliateAddress.streetTwo:'',
                        city:(affiliateAddress.city)?affiliateAddress.city:'',
                        state:(affiliateAddress.state)?affiliateAddress.state:'',
                        country:(affiliateAddress.country)?affiliateAddress.country:'',
                        postcode:(affiliateAddress.postcode)?affiliateAddress.postcode:'',
                        lat_long: (affiliateAddress.googleLocation)?affiliateAddress.googleLocation:'',                    
                    }
                }
                else {
                    addressData = {
                        profileId:profileId,
                        address_id: affiliateAddress.locationId,    
                    }
                }
                this.props.affiliateAddressUpdateAction(addressData);
            }else{
                let formErrors = this.state.formErrors;
                if(affiliateAddress.streetOne===null){
                    formErrors.streetOne = MSG_REQUIRED;
                }
                if(affiliateAddress.streetTwo===null){
                    formErrors.streetTwo = MSG_REQUIRED;
                }  
                if(affiliateAddress.city===null){
                    formErrors.city = MSG_REQUIRED;
                } 
                if(affiliateAddress.state===null){
                    formErrors.state = MSG_REQUIRED;
                }   
                if(affiliateAddress.country===null){
                    formErrors.country = MSG_REQUIRED;
                }                         
                if(affiliateAddress.postcode===null){
                    formErrors.postcode = MSG_REQUIRED;
                } 
                this.setState({formErrors});

            }

        }else if(tab===TAB3){
            let primaryContact = this.state.affiliateData.primaryContact;
            if(formValid(this.state)){
                if(this.state.isPrmCnctList){
                    let primaryContactData= {
                        profileId:profileId,
                        userType: LOGIN_AFFILIATE_GROUP,
                        associate_id:primaryContact.prmyCnctAssUserId,
                        mute_mails:primaryContact.muteMails,        
                        mute_pushs:primaryContact.mutePushs 
                    }
                    this.props.affiliatePrmryCntUpdateAction(primaryContactData);
                }else{
                    
                    let primaryContactData= {
                        profileId:profileId,
                        first_name: primaryContact.firstName,
                        last_name: primaryContact.lastName,
                        contact_number:primaryContact.contactNumber,
                        email:primaryContact.emailAddress,
                        position:primaryContact.position,        
                        mute_mails:primaryContact.muteMails,        
                        mute_pushs:primaryContact.mutePushs       
                    }
                    this.props.affiliatePrmryCntUpdateAction(primaryContactData);
                }                

            }else{
                let formErrors = this.state.formErrors;
                if(primaryContact.firstName===null){
                    formErrors.firstName = MSG_REQUIRED;
                }
                if(primaryContact.lastName===null){
                    formErrors.lastName = MSG_REQUIRED;
                }  
                if(primaryContact.contactNumber===null){
                    formErrors.contactNumber = MSG_REQUIRED;
                } 
                if(primaryContact.emailAddress===null){
                    formErrors.emailAddress = MSG_REQUIRED;
                }                           
    
                this.setState({formErrors});

            }

        }else if(tab===TAB4){
            let profileSettings = this.state.affiliateData.profileSettings;

            // if(parseFloat(profileSettings.crewChiefPayRate) > parseFloat(profileSettings.crewChiefChargeRate)) {
            //     let formErrors = this.state.formErrors;   
            //     // formErrors.crewChiefChargeRate      = MSG_REQUIRED;   
            //     formErrors.crewChiefChargeRateLess  = MSG_CHIEF_CHARGE_RATE_ERROR;   
            //     this.setState({formErrors}); 
            // }
            // else 
            if(profileSettings.travelSettings.travel_module_admin_activate && profileSettings.travelSettings.travel_module_affiliate_activate && profileSettings.travelSettings.travel_fields.length===0) {
                this.setToasterState(true,MSG_TRAVEL_MODULE_FIELDS_ERROR,false);  
                return false;
            } else {
                
                if(formValid(this.state)){    
                    if(this.validateAffiliateTravelFields()) {


                        let tsData = this.state.isSuperAdmin ? {travel_module_admin_activate: profileSettings.travelSettings.travel_module_admin_activate} : profileSettings.travelSettings; 
                        let profileSettingsData= {
                            profileId:profileId,
                            distance_unit: profileSettings.distanceUnit,
                            currency: profileSettings.currency,
                            quote_validity:profileSettings.quoteValidity,
                            minimum_distance:profileSettings.minDistance,
                            crew_count_chief:profileSettings.crewCountChief,
                            unit_rate:profileSettings.rate,
                            app_commission:profileSettings.appCommision,
                            pool_commision:profileSettings.poolCommision,
                            additional_text:profileSettings.additionalText, 
                            time_zone:profileSettings.timeZone,      
                            start_time:profileSettings.startTime.trim()?profileSettings.startTime:'00:15',    
                            timesheet_allowed_time:profileSettings.timeAllowedTime.trim()?profileSettings.timeAllowedTime:'02:00',    
                            checkout_time:profileSettings.checkoutTime.trim()?profileSettings.checkoutTime:'01:00',    
                            supervisor_name:profileSettings.supervisorName.trim()?profileSettings.supervisorName:'Supervisor',
                            staff_name:profileSettings.staffName.trim()?profileSettings.staffName:'Staff',
                            min_shift_length:profileSettings.minShiftLength.trim(),
                            mute_client_emails:profileSettings.muteClientEmails,
                            travel_settings: tsData, 
                        }

                        // crew_chief_pay_bonus:profileSettings.crewChiefPayRate,
                        // crew_chief_bonus:profileSettings.crewChiefChargeRate,
                        this.props.affiliateSettingsUpdateAction(profileSettingsData);
                    }

                }else{
                    let formErrors = this.state.formErrors;         
                    if(profileSettings.minDistance===null){
                        formErrors.minDistance = MSG_REQUIRED;
                    }  
                    if(profileSettings.crewCountChief===null){
                        formErrors.crewCountChief = MSG_REQUIRED;
                    }  
                    // if(profileSettings.crewChiefPayRate===null){
                    //     formErrors.crewChiefPayRate = MSG_REQUIRED;
                    // }
                    // if(profileSettings.crewChiefChargeRate===null){
                    //     formErrors.crewChiefChargeRate = MSG_REQUIRED;
                    // }
                    if(profileSettings.rate===null){
                        formErrors.rate = MSG_REQUIRED;
                    } 
                    if(profileSettings.appCommision===null){
                        formErrors.appCommision = MSG_REQUIRED;
                    }  
                    if(profileSettings.poolCommision===null){
                        formErrors.poolCommision = MSG_REQUIRED;
                    }  
                    if(profileSettings.timeZone===null){
                        formErrors.timeZone = MSG_REQUIRED;
                    }  
                    if(profileSettings.minimumTravelDistance===null) {
                        formErrors.minimumTravelDistance = MSG_REQUIRED; 
                    }                                
        
                    this.setState({formErrors});

                }
            }
        }
    }

    setStateUpdate(affiliate,activity,status,errorData){        
        let formErrors = this.state.formErrors; 
        if(activity===types.AFFILIATE_COMPANYINFO_ADD_SUCCESS){  
            this.setState({profileId:affiliate.id, dynamicFieldsSavedDataLoaded:1});               
            this.setToasterState(true,MSG_PROF_CMPNY_INFO_ADD,true); 
        }else if(activity===types.AFFILIATE_COMPANYINFO_ADD_ERROR){
            if(status===400){                   
                if(errorData.hasOwnProperty('company_name')){
                    formErrors.companyName = errorData.company_name[0];
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }                       
                this.setState(formErrors);
            }else{
                this.setToasterState(true,MSG_AFFILIATE_ADD_ERROR,false);
                // if(errorData.hasOwnProperty('message')){ 
                //     this.setToasterState(true,errorData.message,false);
                // }else{
                //     this.setToasterState(true,JSON.stringify(errorData),false);
                // }
            }
        }else if(activity===types.AFFILIATE_CMPNY_INFO_UPDATE_SUCCESS){
            this.setToasterState(true,MSG_PROF_CMPNY_INFO_ADD,true);  
            // SET NEW LOGO TO STORE 
            let affiliateUpdatedData = this.props.affiliateUpdatedData; 
            if(affiliateUpdatedData.logo && affiliateUpdatedData.logo.length > 1 ) {
                let userGroupData = userGroupUrlCheck(window.location);
                if(userGroupData!==undefined && userGroupData.user_group && userGroupData.user_group===LOGIN_AFFILIATE_GROUP){
                   userGroupData.company_image = affiliateUpdatedData.logo; 
                   setStorage('affiliate', JSON.stringify(userGroupData));
                }
             }
        }else if(activity===types.AFFILIATE_CMPNY_INFO_UPDATE_ERROR){ 
            if(status===400){                
                if(errorData.hasOwnProperty('company_name')){
                    formErrors.companyName = errorData.company_name[0];
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }                          
                this.setState(formErrors);               
            }else{
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }                 
        }else if(activity===types.AFFILIATE_ADDRESS_UPDATE_SUCCESS){               
            this.setToasterState(true,MSG_PROF_ADDRESS_UPDATE,true);
        }else if(activity===types.AFFILIATE_ADDRESS_UPDATE_ERROR){ 
            this.setToasterState(true,JSON.stringify(errorData),false);
        }else if(activity===types.AFFILIATE_PRMRY_CNT_ADD_SUCCESS){
            let emailAddress = this.state.affiliateData.primaryContact.emailAddress; 
            this.setState({
                isPrimaryContactSuccess: true, primaryContactEmailAddress: emailAddress
            });
            this.setToasterState(true,MSG_PROF_PRMY_CNT_ADD,true,false);   
        }else if(activity===types.AFFILIATE_PRMRY_CNT_UPDATE_SUCCESS){
            this.setState({
                isPrimaryContactSuccess: true
            });
            this.setToasterState(true,MSG_PROF_PRMY_CNT_UPDATE,true);   
        }else if(activity===types.AFFILIATE_PRMRY_CNT_UPDATE_ERROR){ 
            if(status===400){
                if(errorData.hasOwnProperty('email')){
                    formErrors.emailAddress = errorData.email[0];
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
                this.setState(formErrors);
            }else{
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }              
        }else if(activity===types.AFFILIATE_SETTINGS_UPDATE_SUCCESS){
            // SET NEW TIMEZONE TO STORE
            let userGroupData = userGroupUrlCheck(this.props.location);
            if(userGroupData!==undefined && userGroupData.user_group && userGroupData.user_group===LOGIN_AFFILIATE_GROUP){
                let timeZoneId = this.state.affiliateData.profileSettings.timeZone;
                let tz = this.state.timeZonesList;
                let newTZ = tz.filter(item => Number(item.id)===Number(timeZoneId)); 
                userGroupData.time_zone = newTZ[0];

                // setStorage('affiliate', JSON.stringify(userGroupData));

                let currencyId = this.state.affiliateData.profileSettings.currency;
                let cur = this.props.currency;
                let newCUR = cur.filter(item => Number(item.id)===Number(currencyId)); 
                userGroupData.profile_currency = newCUR[0].symbol;
                userGroupData.profile_currency_object  = newCUR[0];
                userGroupData.distance_unit = this.state.affiliateData.profileSettings.distance_unit;
                
                setStorage('affiliate', JSON.stringify(userGroupData));
            }

            this.setToasterState(true,MSG_PROF_SETTINGS_UPDATE,true);  
        }else if(activity===types.AFFILIATE_SETTINGS_UPDATE_ERROR){ 
            if(status===400){
                this.setToasterState(true,JSON.stringify(errorData),false);
            }else{
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,JSON.stringify(errorData),false);
                }
            }                                    
        }else if(activity===types.AFFILIATE_EDIT_SUCCESS){ 
            this.setState({
                affiliateData:{
                    companyInfo:{
                        companyName:affiliate.companyName,
                        websiteUrl:affiliate.websiteUrl,
                        companyContactNum:affiliate.companyContactNum,
                        companyEmail:affiliate.companyEmail,
                        companyRegNum:affiliate.companyRegNum,
                        vatNum:affiliate.vatNum,
                        vatTax:affiliate.vatTax,
                        sector:(affiliate.sector)?affiliate.sector:0,
                        subSector:(affiliate.subSector)?affiliate.subSector:0,
                        logo:''
                    },
                    affiliateAddress:{
                        location:'',
                        googleLocation:'',
                        venue:(affiliate.venue) ? affiliate.venue : '',
                        streetOne:(affiliate.streetOne)?affiliate.streetOne:'',
                        streetTwo:(affiliate.streetTwo)?affiliate.streetTwo:'',
                        city:(affiliate.city)?affiliate.city:'',
                        state:(affiliate.state)?affiliate.state:'',
                        country:(affiliate.country)?affiliate.country:'',
                        postcode:(affiliate.postcode)?affiliate.postcode:'',
                        noLocationFound:false,
                    },
                    primaryContact:{
                        prmyCnctAssUserId:affiliate.prmyCnctAssUserId,
                        prmyCnctUserId:affiliate.prmyCnctUserId,
                        firstName:affiliate.firstName,
                        lastName:affiliate.lastName,
                        contactNumber:affiliate.contactNumber,
                        emailAddress:affiliate.emailAddress,
                        position:affiliate.position,
                        emailVerify:affiliate.emailVerify,
                        mutePushs:affiliate.mutePushs,
                        muteMails:affiliate.muteMails
                    },
                    profileSettings:{
                        distanceUnit:affiliate.distanceUnit,
                        currency:affiliate.currency,
                        quoteValidity:affiliate.quoteValidity,
                        minDistance:affiliate.minDistance.search(".00") >= 0 ? parseFloat(affiliate.minDistance).toFixed(1) : affiliate.minDistance,
                        crewCountChief:affiliate.crewCountChief,
                        rate:affiliate.rate?affiliate.rate:0, 
                        appCommision:affiliate.appCommision,
                        poolCommision:affiliate.poolCommision,
                        additionalText:affiliate.additionalText,
                        timeZone:(affiliate.timeZone)?affiliate.timeZone.id:null,  
                        startTime:affiliate.startTime,  
                        timeAllowedTime:affiliate.timeAllowedTime,  
                        checkoutTime:affiliate.checkoutTime, 
                        supervisorName:affiliate.supervisorName, 
                        staffName:affiliate.staffName, 
                        minShiftLength:affiliate.minShiftLength,
                        muteClientEmails:affiliate.muteClientEmails,
                        isPrimaryUserLogin:affiliate.isPrimaryUserLogin,
                        travelSettings: affiliate.travelSettings, 
                        travelModuleMasterFields: affiliate.travelModuleMasterFields, 
                    },  
                    
                    activeTab:TAB1,
                    // crewChiefPayRate:affiliate.crewChiefPayRate, 
                    // crewChiefChargeRate:affiliate.crewChiefChargeRate,
                },
                imgUrl:affiliate.logo,
                isPrmCnctList:affiliate.isPrmCnctList,
                dynamicFieldsSavedData:affiliate.dynamic_fields,
                dynamicFieldsSavedDataLoaded: 1,
                primaryContactEmailAddress: affiliate.emailAddress,
            }); 
            
            if(affiliate.isPrmCnctList){
                let data= {
                    profileId:affiliate.id,
                    userType: LOGIN_AFFILIATE_GROUP
                }
                this.props.primaryUsersListAction(data);
            }
        }else if(activity===types.AFFILIATE_EDIT_ERROR){
            if(status===404){
                this.props.history.push(ROUTE_AFFILIATES)
            }
        }else if(activity===types.RESEND_EMAIL_SUCCESS){
            this.setToasterState(true,MSG_MAIL_RESEND,true,false);
        }else if(activity===types.LIST_CURRENCY_SUCCESS){
            const filteredCurrency = this.props.currency && this.props.currency.filter(item => item.name === 'GBP');
            let affiliateData      = this.state.affiliateData;      
            let profileSettings    = affiliateData.profileSettings;
            profileSettings['currency'] = filteredCurrency[0].id;
            this.setState({affiliateData});
        }
    }

    googleLocSelect = (address) =>{
        let {formErrors} = this.state; 
        let affiliateData = this.state.affiliateData; 
        let locGoogleCodes  = this.state.locGoogleCodes; 

        geocodeByAddress(address)
        .then(results => {            
            affiliateData.affiliateAddress.streetOne = ''; 
            affiliateData.affiliateAddress.streetTwo = ''; 
            affiliateData.affiliateAddress.city = ''; 
            affiliateData.affiliateAddress.state = ''; 
            affiliateData.affiliateAddress.country = ''; 
            affiliateData.affiliateAddress.postcode = '';   
            affiliateData.affiliateAddress.location = results[0].formatted_address?results[0].formatted_address:''; 
            let tmpArr = [];
            tmpArr = address.split(','); 
            affiliateData.affiliateAddress.venue = tmpArr[0]; 

            locGoogleCodes.streetOne = ''; 
            locGoogleCodes.streetTwo = ''; 
            locGoogleCodes.city = ''; 
            locGoogleCodes.state = ''; 
            locGoogleCodes.country = ''; 
            locGoogleCodes.postcode = ''; 

            let allAddress = results[0].address_components;
            let addrTypes = []; 
            let foundVar = 0; 
            let tmpVal = ''; 
            allAddress.forEach(element => {
                addrTypes = element.types;
                foundVar = 0; 
                addrTypes.forEach(item => {
                    tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '') ;
                    if(foundVar===0 && tmpVal!=='') { 
                        if(gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['streetOne'].trim()==='') affiliateData.affiliateAddress['streetOne'] = tmpVal; 
                            else affiliateData.affiliateAddress['streetOne'] += ', '+tmpVal;  

                            if(locGoogleCodes['streetOne'].trim()==='') locGoogleCodes['streetOne'] = item; 
                            else locGoogleCodes['streetOne'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['streetTwo'].trim()==='') affiliateData.affiliateAddress['streetTwo'] = tmpVal; 
                            else affiliateData.affiliateAddress['streetTwo'] += ', '+tmpVal; 
                            if(locGoogleCodes['streetTwo'].trim()==='') locGoogleCodes['streetTwo'] = item; 
                            else locGoogleCodes['streetTwo'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['city'].trim()==='') affiliateData.affiliateAddress['city'] = tmpVal; 
                            else affiliateData.affiliateAddress['city'] += ', '+tmpVal; 
                            if(locGoogleCodes['city'].trim()==='') locGoogleCodes['city'] = item; 
                            else locGoogleCodes['city'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['state'].trim()==='') affiliateData.affiliateAddress['state'] = tmpVal; 
                            else affiliateData.affiliateAddress['state'] += ', '+tmpVal; 
                            if(locGoogleCodes['state'].trim()==='') locGoogleCodes['state'] = item; 
                            else locGoogleCodes['state'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['country'].trim()==='') affiliateData.affiliateAddress['country'] = tmpVal; 
                            else affiliateData.affiliateAddress['country'] += ', '+tmpVal; 
                            if(locGoogleCodes['country'].trim()==='') locGoogleCodes['country'] = item; 
                            else locGoogleCodes['country'] += ', '+item; 
                        }
                        else if(gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                            foundVar = 1; 
                            if(affiliateData.affiliateAddress['postcode'].trim()==='') affiliateData.affiliateAddress['postcode'] = tmpVal; 
                            else affiliateData.affiliateAddress['postcode'] += ', '+tmpVal; 
                            if(locGoogleCodes['postcode'].trim()==='') locGoogleCodes['postcode'] = item; 
                            else locGoogleCodes['postcode'] += ', '+item; 
                        }
                    }
                })
            })

            getLatLng(results[0]).then(latLng=>{
                affiliateData.affiliateAddress['googleLocation'] = latLng.lat+','+latLng.lng;
            })
        }).then( () => {
            formErrors['streetOne'] = '';
            formErrors['city'] = '';
            formErrors['state'] = '';
            formErrors['country'] = '';
            formErrors['postcode'] = '';
            this.setState({affiliateData:affiliateData,locGoogleCodes:locGoogleCodes,formErrors});
        })
        .catch(error => console.error('Error', error));
    }

    onGetGoogleLoc = (e) =>{
        const {name}  = e.target;
        let affiliateData = this.state.affiliateData;        
        affiliateData.affiliateAddress[name] = e.target.checked;
        // const instance = this._typeahead.getInstance()
        // instance.clear();
        affiliateData.affiliateAddress['locationId'] = '';
        affiliateData.affiliateAddress['venue'] = '';
        affiliateData.affiliateAddress['googleLocation'] = '';
        affiliateData.affiliateAddress['streetOne'] = '';
        affiliateData.affiliateAddress['streetTwo'] = '';
        affiliateData.affiliateAddress['city'] = '';
        affiliateData.affiliateAddress['state'] = '';
        affiliateData.affiliateAddress['country'] = '';
        affiliateData.affiliateAddress['postcode'] = '';
        this.setState({affiliateData});
    }

    onCropChange = crop => {
        this.setState({ crop })
    }
 
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedArea:croppedArea,croppedAreaPixels:croppedAreaPixels})
    }
 
    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    componentDidUpdate(prevProps) {
        const { affiliate, status, activity, errorData, dynFieldsStatus, dynFieldsActivity, timezonesListStatus, timezonesListActivity } = this.props;  
        
        if (activity !== prevProps.activity) {
            this.setStateUpdate(affiliate,activity,status,errorData);
            this.props.clearAction();
        }

        // CHECKING DYNAMIC FIELDS DATA LISTING 
        if (dynFieldsActivity && (dynFieldsStatus !== prevProps.dynFieldsStatus || dynFieldsActivity!==prevProps.dynFieldsActivity)) {
            var arrResp = dynFieldsActivity.split('~~'); 
            var actString = arrResp[0]; 
            
            // types.DYNAMIC_FIELDS_LIST_SUCCESS, types.DYNAMIC_FIELDS_LIST_ERROR
            if(actString===types.DYNAMIC_FIELDS_LIST_SUCCESS) {  
                if(this.props.hasOwnProperty('dynFieldsAllItems')) {
                    if(this.props.dynFieldsAllItems.length===0) {
                        this.setState({dynFieldsAllItems: []}); 
                    }
                    else {                      
                        let tmpObj = {};
                        let fieldsObj = {};
                        let allPagesObj = []; 
                        this.props.dynFieldsAllItems.forEach((rObj) => { 
                            if(!Array.isArray(rObj.field_details)) rObj.field_details = []; // IF OBJECT {} RETURNED, CONVERT TO ARRAY 
                            if(rObj.show_tab && rObj.field_details.length > 0) {
                                fieldsObj =  rObj.field_details; 
                                let iconName = ''; 
                                if(!rObj.icon_name || rObj.icon_name===null || rObj.icon_name.trim().length===0) {
                                    let filterObj = {pageName:'', iconName:''}; 
                                    filterObj = DYNAMIC_PAGE_ICONS.filter(pageDet => pageDet.pageName.trim().toLowerCase()===rObj.name.trim().toLowerCase()); // DEFINED IN staticConfigs.js
                                    iconName = filterObj[0].iconName; 
                                }
                                else {
                                    iconName = rObj.icon_name; 
                                }

                                tmpObj = {
                                    id:rObj.id, name:rObj.name, field_details:fieldsObj, show_tab:rObj.show_tab, icon_name:iconName, user_type:rObj.user_type, master_id:rObj.master_id
                                };

                                allPagesObj.push(tmpObj);
                            }
                            
                        });
                        this.setState({dynFieldsAllItems: allPagesObj}); 
                    }
                } 
                else { 
                    this.setState({dynFieldsAllItems: []}); 
                }
            }  
            else if(actString===types.DYNAMIC_FIELDS_LIST_ERROR) { 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ERROR});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            } 
            else if(actString===types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS) { 
                this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            } 
            else if(actString===types.DYNAMIC_FIELDS_DATA_SAVE_ERROR) { 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 4000);
            } 
        }

        if ((timezonesListStatus !== prevProps.timezonesListStatus || timezonesListActivity!==prevProps.timezonesListActivity)) {
            let arrResp = (timezonesListActivity) ? timezonesListActivity.split('~~') : []; 
            let actString = arrResp[0]; 
            if(actString===types.TIMEZONES_LIST_SUCCESS) { 
                if(timezonesListStatus===200) {
                    let tz = this.props.timeZonesAllItems;
                    let newTZ = tz.filter(item => item.region.trim().toLowerCase()===DEFAULT_TIME_ZONE.trim().toLowerCase()); 
                    let defTZId = 0 ;
                    if(newTZ.length) defTZId = newTZ[0].id; 
                    let affiliateData = this.state.affiliateData; 
                    if(!affiliateData.profileSettings.timeZone) affiliateData.profileSettings.timeZone = defTZId;
                    this.setState({affiliateData:affiliateData,defaultTimeZoneId:defTZId,timeZonesList:this.props.timeZonesAllItems}) 
                }
                else {
                    // timezonesListErrorData
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            } 
            else if(actString===types.TIMEZONES_LIST_ERROR) { 
                // timezonesListErrorData
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            } 
        } 
    }

    componentDidMount() {
        if(this.state.profileId!==undefined){
            const profileId = this.state.profileId; 
            this.props.affiliateEditAction(profileId);       
        }

        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        
        let groupId = 0; 
        if(this.props.location.pathname.indexOf((ROUTE_AFFILIATE_PROFILE+'/')) >=0) {
            groupId = LOGIN_AFFILIATE_GROUP; 
        } 
        else if(this.props.location.pathname.indexOf((ROUTE_AFFILIATE_PROFILE_MANAGE)) >=0) {
            groupId = LOGIN_AFFILIATE_GROUP; 
        }

        

        let listDynData = {groupId: groupId, reqFrom:userGroup}; 
        this.setState({listDynData:listDynData}, () => { 
            this.props.dynamicFieldsListAction(listDynData);
        }); 

        

        document.title = LBL_APP_NAME+" - "+LBL_COMPANY_PROFILE;
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }
        this.props.sectorAllListAction();   
        this.props.subSectorAllListAction();
        this.props.currencyListAction();      
    }

    onSaveData = (e) => {
        console.log('onSaveData'); 
    }
    
    onModalFormReset = () => {
        console.log('onModalFormReset'); 
    }

    render(){
      
        const { sectors,subSectors,status,currency,locationsList, prmryUsers} = this.props;
        const { toastMessage,toastFlag,toastSuccess, profileId} = this.state;    
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        let companyName = ''; 
        if(this.state.affiliateData.companyInfo.companyName) companyName = this.state.affiliateData.companyInfo.companyName; 

        let pcEmail = this.state.primaryContactEmailAddress ? this.state.primaryContactEmailAddress : ''; 

        return(
            <React.Fragment>

                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                {userGroup===LOGIN_AFFILIATE_GROUP ? <div className='row' style={{width: '100%'}}>
                    <div className='margin-left-30 margin-bottom-5 padding-left-3 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link></div>
                </div>:<></>}
                <Tab.Container id="profile-tab" defaultActiveKey="company-info-tab">
                    <Col md={4} lg={2}>
                        <Nav variant="pills" className="nav flex-column nav-pills box">

                            <Nav.Link onClick={(e) => this.onTabChange(e, TAB1)} eventKey="company-info-tab"><i className="la la-cube"></i><small>Company Info</small></Nav.Link>

                            {profileId && profileId > 0 && <Nav.Link className={profileId===undefined?'disabled':''} onClick={(e) => this.onTabChange(e, TAB3)} eventKey="company-primary-contact-tab"><i className="las la-user-astronaut"></i><small> Primary Contact</small></Nav.Link>}

                            {pcEmail && pcEmail.length > 1 && <Nav.Link className={profileId===undefined?'disabled':''} onClick={(e) => this.onTabChange(e, TAB2)} eventKey="company-address-tab"><i className="las la-map-marker-alt"></i><small> Address</small></Nav.Link>}

                            {pcEmail && pcEmail.length > 1 && <Nav.Link className={profileId===undefined?'disabled':''} onClick={(e) => this.onTabChange(e, TAB4)} eventKey="company-settings-tab"><i className="las la-cog"></i><small> Settings</small></Nav.Link>}     

                            {pcEmail && pcEmail.length > 1 && (this.state.profileId===undefined || this.state.dynamicFieldsSavedDataLoaded > 0) && this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item,index) => { 
                                if(STR_VEHICLE_INFO.toLowerCase()==item.name.toLowerCase()) {
                                    return null; 
                                }
                                else {
                                    return ( <Nav.Link eventKey={"company-Dynamic-tab_"+index} key={index} onClick={ (e) => this.state.activePageId!==item.id ? this.changePage(e, item.id) : '' } className={((this.state.userGroup===LOGIN_SUPER_ADMIN_GROUP && this.state.activePageId===item.id) ? "text-bold" : '')+(profileId===undefined?' disabled':'')} ><i className={item.icon_name}></i><small> {item.name}</small></Nav.Link>
                                    )
                                }
                                
                            } ) }
                        </Nav>
                    </Col>
                    <Col md={9} lg={8} className="space-reducer right-content">
                        <Tab.Content>
                            <Tab.Pane eventKey="company-info-tab">
                                <CompanyInfo showNameInHeader={companyName} sectors={sectors} subSectors={subSectors} saveFormData={this.saveFormData} onPhoneInputChange={this.onPhoneInputChange} onHandleChange={(e) => this.onHandleChange(e, TAB1)} onCropChange={this.onCropChange} onCropComplete={this.onCropComplete} onZoomChange={this.onZoomChange} {...this.state} />                                
                            </Tab.Pane>
                            <Tab.Pane eventKey="company-address-tab">
                               <Address showNameInHeader={companyName} locations={locationsList} updateFormData={(e) => this.updateFormData(e, TAB2)} onHandleChange={(e) => this.onHandleChange(e, TAB2)} onSelectLocation={(e) => this.onSelectLocation(e)} {...this.state} onsearchLocation={this.onSearchLocation} onGetGoogleLoc={(e) => this.onGetGoogleLoc(e)} googleLocSelect={(e) => this.googleLocSelect(e)} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="company-primary-contact-tab">
                                <PrimaryContact showNameInHeader={companyName} users={prmryUsers} updateFormData={(e) => this.updateFormData(e, TAB3)} onContactInputChange={this.onContactInputChange} onHandleChange={(e) => this.onHandleChange(e, TAB3)} onSelectPrmyUser={(e) => this.onSelectPrmyUser(e)}  resendEmail={(e) => this.resendEmail(e)} {...this.state} />
                            </Tab.Pane>
                            <Tab.Pane eventKey="company-settings-tab">
                                <Settings showNameInHeader={companyName} currency={currency} updateFormData={(e) => this.updateFormData(e, TAB4)} onHandleChange={(e) => this.onHandleChange(e, TAB4)} onHandleChangeStartTime={(e) => this.onHandleChangeStartTime(e, TAB4)} onBlurStartTime={(e) => this.onBlurStartTime(e, TAB4)} onHandleChangeTimeAllowedTime={(e) => this.onHandleChangeTimeAllowedTime(e, TAB4)} onBlurTimeAllowedTime={(e) => this.onBlurTimeAllowedTime(e, TAB4)} onHandleChangeMinShiftLength={(e) => this.onHandleChangeMinShiftLength(e, TAB4)} onHandleTravelTimeRounding={(e) => this.onHandleTravelTimeRounding(e, TAB4)} onBlurMinShiftLength={(e) => this.onBlurMinShiftLength(e, TAB4)} 
                                onBlurTravelTimeRounding={(e) => this.onBlurTravelTimeRounding(e, TAB4)} onHandleChangeCheckoutTime={(e) => this.onHandleChangeCheckoutTime(e, TAB4)} onBlurCheckoutTime={(e) => this.onBlurCheckoutTime(e, TAB4)} onHandleChangeTravelFields={this.onHandleChangeTravelFields} {...this.state} />                           
                            </Tab.Pane>                           
                            {(this.state.profileId > 0 && this.state.dynamicFieldsSavedDataLoaded > 0) && this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item,index) => { 
                                 return(<Tab.Pane eventKey={"company-Dynamic-tab_"+index} key={index} >
                                     <DynamicFieldsDetails showNameInHeader={companyName}  dynamicFieldsDataSaveAction={(e) => this.props.dynamicFieldsDataSaveAction(e)} 
                                     {...this.state} headerText={item.name} dynFieldsActiveItem={item} dynamicFieldsFor={LOGIN_AFFILIATE_GROUP} />  
                                </Tab.Pane>
                                ); 
                            } ) }
                        </Tab.Content>
                    </Col>
                </Tab.Container> 

                <ModalWindow ref={this.logoModalCropper} type="imageCropper" saveFormData={ (e)=>this.cropImage(e)}>
                    <Cropper
                        image={this.state.imgUrl}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                      />
                </ModalWindow>    

                <ModalWindow ref={this.modalTravelModuleFields} header={LBL_TRAVEL_MODULE_FIELDS_CHOOSE} type="save" 
                saveFormData={(e) => this.onSaveData(e)}
                resetModalForm={this.onModalFormReset} >
                                {"Are you sure you want to delete document ?"}
                </ModalWindow>

            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => { 

    return {
        affiliate:state.affiliates.item,
        status:state.affiliates.status,
        activity:state.affiliates.activity,
        affiliateUpdatedData:state.affiliates.affiliateUpdatedData,
        sectors:state.affiliates.sectors,
        subSectors:state.affiliates.subSectors,
        locationsList:state.affiliates.locations,
        currency:state.affiliates.currency,
        prmryUsers:state.affiliates.prmryUsers,
        errorData:state.affiliates.errorData,
        dynFieldsStatus:state.dynamicFields.dynFieldsStatus,
        dynFieldsActivity:state.dynamicFields.dynFieldsActivity,
        dynFieldsAllItems:state.dynamicFields.dynFieldAllItems,
        timeZonesAllItems:state.timeZones.timezonesList,
        timezonesListStatus:state.timeZones.timezonesListStatus,
        timezonesListActivity:state.timeZones.timezonesListActivity,
        timezonesListErrorData:state.timeZones.timezonesListErrorData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        sectorAllListAction:sectorAllListAction,  
        subSectorAllListAction:subSectorAllListAction,
        affiliateCompanyInfoAddAction:data=>affiliateCompanyInfoAddAction(data),
        affiliateEditAction:id=>affiliateEditAction(id),
        affiliateAddressUpdateAction:data=>affiliateAddressUpdateAction(data),
        affiliatePrmryCntUpdateAction:data=>affiliatePrmryCntUpdateAction(data),
        masterLocationListAction:data=>masterLocationListAction(data),
        affiliateSettingsUpdateAction:data=>affiliateSettingsUpdateAction(data),
        affiliateCmnyInfoUpdateAction:data=>affiliateCmnyInfoUpdateAction(data),
        currencyListAction:currencyListAction,
        clearAction:clearAction,
        primaryUsersListAction:primaryUsersListAction,
        dynamicFieldsListAction:dynamicFieldsListAction,
        resendEmailAction:resendEmailAction,
        dynamicFieldsDataSaveAction:dynamicFieldsDataSaveAction, 
        timeZonesListAction:timeZonesListAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(AffiliateProfileComponent);
